import React from "react";
import { useParams } from "react-router-dom";
import ShopLayout from "../Layout";
import OrderDetails from "../../Order/OrderDetails";

const ShopOrderDetails = ({ params }: any) => {
  const route = useParams();

  return (
    <React.Fragment>
      <ShopLayout shopId={(route as any)?.shopId as string}>
        <div className="product-list-item-area white-bg">
          <OrderDetails />
        </div>
      </ShopLayout>
    </React.Fragment>
  );
};

export default ShopOrderDetails;
